import { render } from "./ModalSendFile.vue?vue&type=template&id=6436abb7&scoped=true"
import script from "./ModalSendFile.vue?vue&type=script&lang=js"
export * from "./ModalSendFile.vue?vue&type=script&lang=js"

import "./ModalSendFile.vue?vue&type=style&index=0&id=6436abb7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6436abb7"]])

export default __exports__